export const isTableauOnlyRole = (state) => {
  const { roles } = state.App.activeAccount;
  return roles?.length === 1 && roles[0] === 'TableauAccess';
};
